import React from 'react';

import AlertBadge from './AlertBadge';

interface ComponentProps {
  id: string;
  isOverAllocated?: boolean;
  supplementRatesStale?: boolean;
}

/**
 * Groups the budget-list row warning badges into a single cell (mirrors ActionButtons).
 * Each AlertBadge renders nothing when its flag is false, so the cell is empty when the
 * budget has no warnings, shows one icon when a single condition applies, or both side by side.
 */
const BudgetAlertBadges: React.FC<ComponentProps> = ({
  id,
  isOverAllocated = false,
  supplementRatesStale = false,
}) => (
  <div className="d-flex justify-content-start align-items-center gap-2">
    <AlertBadge
      id={`${id}-over-allocated`}
      showAlert={isOverAllocated}
      color={isOverAllocated ? 'red' : undefined}
      tooltip={isOverAllocated ? 'Budget is over allocated' : undefined}
    />
    <AlertBadge
      id={`${id}-supplement-rates-stale`}
      showAlert={supplementRatesStale}
      color={supplementRatesStale ? 'orange' : undefined}
      tooltip={supplementRatesStale ? 'Supplement rates need to be updated' : undefined}
    />
  </div>
);

export default BudgetAlertBadges;
